import React from "react"
import Dialog from "material-ui/Dialog"
import { Snackbar } from "material-ui"
import { ITextProgressSnackbarContent } from "../../models"
import { grey700 } from "material-ui/styles/colors"
interface IProps {
    content: ITextProgressSnackbarContent
    autoHideDuration?: number
    close(): void
}
interface IState {
    progressCount: number
}

export default class TextProgressSnackbar extends React.Component<IProps, IState> {
    private progressMaxCount = 3
    private progressTimer
    constructor(props: IProps) {
        super(props)
        this.state = {
            progressCount: 0
        }
    }

    componentDidMount() {
        this.progressTimer = setInterval(() => {
            this.setState({ progressCount: this.state.progressCount + 1 > this.progressMaxCount ? 0 : this.state.progressCount + 1 })
        }, 1000)
    }

    componentWillUnmount() {
        this.progressTimer &&
            clearInterval(this.progressTimer)
    }

    render() {
        return (
            this.props.content.progressText ?
                <Dialog open style={{ textAlign: "center" }}>
                    <div style={{ fontSize: 18, position: "relative", display: "inline-block", color: grey700 }}>
                        {this.props.content.progressText}
                        <div style={{ position: "absolute", top: 0, right: -25, width: 20 }}>
                            <div style={{ textAlign: "left" }}>
                                {Array(this.progressMaxCount ).fill(".").map((i, index) => {
                                    return(
                                    <span key={index} style={{ margin: 0.5, display: index + 1 > this.state.progressCount && "none" }}>.</span>
                                    )
                                }
                                )}
                            </div>
                        </div>
                    </div>
                </Dialog> :
                this.props.content.snackbarText &&
                <Snackbar
                    open
                    bodyStyle={{ maxWidth: null, width: "max-content" }}
                    message={this.props.content}
                    autoHideDuration={this.props.autoHideDuration ? this.props.autoHideDuration : 5000}
                    onRequestClose={this.props.close}
                />
        )
    }
}
